const FLIPPINGBOOK_ORIGIN = 'https://online.flippingbook.com';
const FLIPPINGBOOK_PUBLICATION_PATH = /^\/view\/[A-Za-z0-9_-]+\/?$/;
const PDF_VIEWER_BASE_URL =
	'/wp-content/plugins/blackstoneeit-wp-plugin-blocks/assets/flipbook-js-master/web/viewer.html';

/**
 * Validates a FlippingBook URL before using it as an external destination.
 *
 * @param {unknown} value Candidate publication URL.
 * @return {string} A normalized FlippingBook URL, or an empty string.
 */
export function getFlippingBookUrl( value ) {
	if ( typeof value !== 'string' || value.trim() === '' ) {
		return '';
	}

	try {
		const url = new URL( value.trim() );

		if (
			url.origin !== FLIPPINGBOOK_ORIGIN ||
			url.username !== '' ||
			url.password !== '' ||
			! FLIPPINGBOOK_PUBLICATION_PATH.test( url.pathname )
		) {
			return '';
		}

		return url.href;
	} catch {
		return '';
	}
}

/**
 * Resolves the viewer for a PDF library item.
 *
 * When the site-wide FlippingBook viewer mode is enabled, a valid FlippingBook
 * URL is the only available viewer and there is never a PDF/FancyBox fallback.
 * When the mode is disabled, the legacy PDF viewer URL and its FancyBox modal
 * are preserved and any stored FlippingBook URL is ignored.
 *
 * @param {Object}  item                Library API item.
 * @param {boolean} flippingBookEnabled Whether the site uses the FlippingBook viewer mode.
 * @return {{url: string, opensInNewTab: boolean, isAvailable: boolean, usesFancybox: boolean}} Viewer configuration.
 */
export function getLibraryViewer( item, flippingBookEnabled ) {
	const flippingBookUrl = getFlippingBookUrl(
		item?.meta_data?.flippingbook_url
	);

	if ( flippingBookEnabled ) {
		if ( flippingBookUrl ) {
			return {
				url: flippingBookUrl,
				opensInNewTab: true,
				isAvailable: true,
				usesFancybox: false,
			};
		}

		return {
			url: '',
			opensInNewTab: false,
			isAvailable: false,
			usesFancybox: false,
		};
	}

	const pdfUrl = item?.meta_data?.pdf;

	if ( typeof pdfUrl !== 'string' || pdfUrl === '' ) {
		return {
			url: '',
			opensInNewTab: false,
			isAvailable: false,
			usesFancybox: false,
		};
	}

	return {
		url: `${ PDF_VIEWER_BASE_URL }?file=${ pdfUrl }#magazineMode=true`,
		opensInNewTab: false,
		isAvailable: true,
		usesFancybox: true,
	};
}
